module.exports = __webpack_public_path__ + "img/blms-menu-master-data-icon.90900dbe.svg";